"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _nrdLogger = _interopRequireDefault(require("./NRD/nrdLogger"));

var _Logger = _interopRequireDefault(require("./Legacy/Logger"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _default(logger) {
  return FetchLoggerInstance(logger);
}

function FetchLoggerInstance(_ref) {
  var name = _ref.name,
      additionalLogData = _ref.additionalLogData,
      globalLogData = _ref.globalLogData,
      batch = _ref.batch,
      env = _ref.env,
      _ref$enableNRD = _ref.enableNRD,
      enableNRD = _ref$enableNRD === void 0 ? false : _ref$enableNRD,
      _ref$batchSize = _ref.batchSize,
      batchSize = _ref$batchSize === void 0 ? 10 : _ref$batchSize,
      _ref$batchInterval = _ref.batchInterval,
      batchInterval = _ref$batchInterval === void 0 ? 15000 : _ref$batchInterval;

  if (enableNRD) {
    return (0, _nrdLogger["default"])(name, globalLogData, batchSize, batchInterval);
  } else {
    return (0, _Logger["default"])(name, additionalLogData, batch, env);
  }
}